/* Ares Acres — Illustrated Parts Finder (DJI Agras)
 * Model → System → Assembly → numbered figure → part card → complete parts list → bulk add to cart.
 * Data: assets/ares-parts-<family>.json (built from Ares' verified DJI part lists + Shopify SKU match).
 * No framework. Shopify AJAX cart (/cart/add.js) + Section Rendering for the cart bubble.
 */
(function () {
  'use strict';
  var root = document.getElementById('ares-parts-finder');
  if (!root) return;

  var CFG = {
    urls: JSON.parse(root.getAttribute('data-bundles') || '{}'),
    shards: JSON.parse(root.getAttribute('data-shards') || '{}'),
    images: root.getAttribute('data-images-url') || '',
    doctorUrl: root.getAttribute('data-doctor-url') || '/pages/dji-doctor',
    supportAnchor: root.getAttribute('data-support-anchor') || '#ares-support',
    currency: root.getAttribute('data-currency') || 'USD',
    moneyFormat: root.getAttribute('data-money-format') || '${{amount}}',
    // handle -> image URL for each system collection, rendered by Liquid so the
    // tiles always show the same photography as the collection pages.
    systemImages: JSON.parse(root.getAttribute('data-system-images') || '{}')
  };
  // The finder is embedded on the DJI Doctor page as well, where the Doctor already
  // owns the h1. A second h1 on one page is an SEO and screen-reader defect.
  var HEADING_TAG = (root.getAttribute('data-heading-level') || 'h1').toLowerCase() === 'h2' ? 'h2' : 'h1';
  var MODEL_FAMILY = { T100: 't100', T70P: 't100', T55: 't100', T50: 't50', T25: 't50', T25P: 't50', T40: 't40', T20P: 't40' };
  var MODELS = ['T100', 'T70P', 'T55', 'T50', 'T25', 'T25P', 'T40', 'T20P'];
  var SYSTEM_ICON = { spraying: '💧', propulsion: '🌀', power: '🔋', navigation: '📡', spreading: '🌾', airframe: '🛠', controller: '🎮', generator: '⚡', tools: '🧰' };

  var state = { model: null, family: null, data: null, bundles: {}, system: null, asm: null, fig: null, tab: 'diagram',
                sel: {}, qty: {}, live: {}, images: null, q: '' };

  /* ---------- utils ---------- */
  function $(sel, el) { return (el || root).querySelector(sel); }
  function $$(sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); }
  function h(tag, attrs, children) {
    var el = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      if (k === 'class') el.className = attrs[k];
      else if (k === 'html') el.innerHTML = attrs[k];
      else if (k === 'text') el.textContent = attrs[k];
      else if (k.indexOf('on') === 0) el.addEventListener(k.slice(2), attrs[k]);
      else if (attrs[k] !== null && attrs[k] !== undefined && attrs[k] !== false) el.setAttribute(k, attrs[k] === true ? '' : attrs[k]);
    });
    (children || []).forEach(function (c) { if (c === null || c === undefined || c === false) return; el.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return el;
  }
  function money(v) {
    var n = typeof v === 'number' ? v : parseFloat(v || 0);
    var s = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return CFG.moneyFormat.replace(/\{\{\s*amount\s*\}\}/, s).replace(/\{\{\s*amount_no_decimals\s*\}\}/, s.split('.')[0]);
  }
  function norm(s) { return (s || '').toUpperCase().replace(/\s+/g, ''); }
  function track(name, payload) {
    var p = Object.assign({ event: name, tool: 'parts_finder', model: state.model, family: state.family, system: state.system, assembly: state.asm ? state.asm.k : null, at: new Date().toISOString() }, payload || {});
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, p); } catch (e) {}
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(p); } catch (e) {}
    try { if (typeof gtag === 'function') gtag('event', name, p); } catch (e) {}
  }
  function setHash() {
    var parts = [];
    if (state.model) parts.push('model=' + state.model);
    if (state.system) parts.push('system=' + state.system);
    if (state.asm) parts.push('asm=' + encodeURIComponent(state.asm.k));
    if (state.fig !== null && state.fig !== undefined) parts.push('fig=' + encodeURIComponent(state.fig));
    // `pf_view` NOT `view`: `view` is Shopify's reserved alternate-template
    // parameter. A URL carrying ?view=diagrams makes Shopify look for a template
    // named page.<suffix>.diagrams and render a blank page when it is missing.
    if (state.tab !== 'diagram') parts.push('pf_view=' + state.tab);
    var hash = parts.length ? '#' + parts.join('&') : '';
    if (history.replaceState) history.replaceState(null, '', location.pathname + location.search + hash);
  }
  // A query string encodes a space as '+', which decodeURIComponent does NOT undo -
  // "?q=spray+pump" arrived in the search box as the literal "spray+pump".
  function dec(v) { try { return decodeURIComponent(String(v).replace(/\+/g, '%20')); } catch (e) { return String(v); } }
  function readParams() {
    var p = {};
    // Accept the legacy `tab` key and the reserved `view` key as aliases of
    // pf_view so old links and shared URLs keep working.
    (location.search.replace(/^\?/, '') + '&' + location.hash.replace(/^#/, '')).split('&').forEach(function (kv) {
      if (!kv) return; var i = kv.indexOf('='); if (i < 0) return;
      p[dec(kv.slice(0, i))] = dec(kv.slice(i + 1));
    });
    if (p.pf_view && !p.tab) p.tab = p.pf_view;
    if (p.view && !p.tab) p.tab = p.view;
    return p;
  }

  /* ---------- data ---------- */
  function loadFamily(fam) {
    if (state.bundles[fam]) return Promise.resolve(state.bundles[fam]);
    return AresAssets.loadJSON(CFG.shards, 'ares-parts-' + fam + '.json', CFG.urls[fam])
      .then(function (d) { d.fam = fam; state.bundles[fam] = d; return d; });
  }
  function loadImages() {
    if (state.images || !CFG.images) return Promise.resolve(state.images || {});
    return fetch(CFG.images).then(function (r) { return r.ok ? r.json() : {}; }).then(function (j) { state.images = j || {}; return state.images; }).catch(function () { state.images = {}; return {}; });
  }
  function partOf(matIdx, data) { data = data || state.data; var m = data.mat[matIdx]; return m && m.p >= 0 ? data.parts[m.p] : null; }
  function partState(part) {
    if (!part) return { key: 'unlisted', label: 'Not listed yet', cls: 'apf-badge--warn' };
    if (part.st !== 'ACTIVE') return { key: 'unlisted', label: 'Not listed yet', cls: 'apf-badge--warn' };
    var live = state.live[part.h];
    var avail = live ? live.available : (part.inv > 0);
    if (!avail) return { key: 'oos', label: 'Out of stock', cls: 'apf-badge--bad' };
    return { key: 'ok', label: 'Available', cls: 'apf-badge--ok' };
  }
  function livePrice(part) { var l = state.live[part.h]; return l && l.price != null ? l.price : parseFloat(part.pr || 0); }
  /* ---------------------------------------------------------------------------
     Variant resolution.

     A DJI material number does not always identify one variant. Two real shapes in
     this catalog:
       - Model-compatibility selectors: one listing carries the same material number
         across variants titled "DJI T100", "DJI T70P", "DJI T55"... Taking variants[0]
         would hand a T50 operator the T100 part.
       - Genuinely different parts under one number: one listing carries variants
         "Upper Clock-Wise (CW)", "Upper Counter Clock-Wise (CCW)", "Lower Clock-Wise
         (CW)", "Lower Counter Clock-Wise" all under the same SKU. Nothing in the data
         says which one the diagram position means.

     So: match the recorded variant id; else match the variant that names the chosen
     aircraft; else refuse to choose. Refusing is the point — the whole promise of this
     tool is the EXACT part, and silently adding variants[0] is how a customer receives
     a clockwise propeller for a counter-clockwise position.
  --------------------------------------------------------------------------- */
  function variantNamesModel(v, want) {
    if (!want) return false;
    var t = String(v && v.title || '').toUpperCase().replace(/DJI/g, '').replace(/AGRAS/g, '');
    return t.split(/[^A-Z0-9]+/).filter(Boolean).indexOf(want) >= 0;
  }
  function fetchLive(part) {
    if (!part || state.live[part.h]) return Promise.resolve(state.live[part.h]);
    return fetch('/products/' + part.h + '.js').then(function (r) { if (!r.ok) throw 0; return r.json(); }).then(function (p) {
      var vs = p.variants || [];
      var v = null, ambiguous = false;
      for (var i = 0; i < vs.length; i++) { if (vs[i].id === part.vid) { v = vs[i]; break; } }
      if (!v && vs.length === 1) v = vs[0];
      if (!v && vs.length > 1) {
        var want = String(state.model || '').toUpperCase();
        var hits = vs.filter(function (x) { return variantNamesModel(x, want); });
        if (hits.length === 1) v = hits[0]; else ambiguous = true;
      }
      if (!v) ambiguous = true;
      var rec = { available: v ? v.available : false, price: v ? v.price / 100 : null, variantId: v ? v.id : null,
                  ambiguous: ambiguous, variantCount: vs.length, variantTitle: v ? v.title : null,
                  image: (v && v.featured_image && v.featured_image.src) || (p.featured_image) || (p.images && p.images[0]) || null, title: p.title };
      state.live[part.h] = rec; return rec;
    }).catch(function () { state.live[part.h] = { available: part.inv > 0, price: parseFloat(part.pr || 0), variantId: part.vid, ambiguous: false, image: null }; return state.live[part.h]; });
  }

  /* ---------- search ---------- */
  var MAT_RE = /^[A-Z]{2}\.[A-Z]{2}\.[A-Z]{0,3}\d{3,}/;

  /* ---------------------------------------------------------------------------
     Keyword search across the whole indexed catalog, not just DJI names.
     Two defects this fixes:
       1. The DJI parts-list names are singular ("Propeller (CCW)"), so a customer
          typing the natural plural "propellers" matched ZERO of 358 T100 records.
       2. Only m.n (the DJI parts-list name) was searched. The sellable Shopify
          titles - "DJI Agras T100 OEM Propellers CCW (Pair)", "Propeller Clip
          Gasket Set (16 Pcs)" - were never in the haystack, so sets, pairs, kits
          and gaskets were invisible to the query that should surface them.
  --------------------------------------------------------------------------- */
  function stem(t) {
    if (t.length > 4 && /ies$/.test(t)) return t.slice(0, -3) + 'y';
    if (t.length > 4 && /(?:ses|xes|zes|ches|shes)$/.test(t)) return t.slice(0, -2);
    if (t.length > 3 && /s$/.test(t) && !/ss$/.test(t)) return t.slice(0, -1);
    return t;
  }
  // Each query token becomes a small set of accepted surface forms: the token,
  // its stem, and any synonyms the shared component vocabulary knows about.
  function expandTokens(q) {
    var raw = String(q || '').toLowerCase().split(/[^a-z0-9.\-]+/).filter(Boolean);
    return raw.map(function (t) {
      var forms = {}, add = function (x) { if (x) forms[x] = 1; };
      add(t); add(stem(t));
      var C = (typeof window !== 'undefined' && window.AresIntent) ? window.AresIntent.COMPONENTS : null;
      if (C) {
        Object.keys(C).forEach(function (id) {
          var syn = C[id].syn || [];
          var matches = syn.some(function (sv) { var l = sv.toLowerCase(); return l === t || stem(l) === stem(t); });
          if (matches) syn.forEach(function (sv) { add(sv.toLowerCase()); add(stem(sv.toLowerCase())); });
        });
      }
      return { raw: t, forms: Object.keys(forms) };
    });
  }
  // Word-boundary matching. Plain substring is wrong here: the synonym "prop"
  // is a prefix of "Propulsion", so a propeller search was returning propulsion
  // cables and motors. Single-word forms must match a whole word; multi-word
  // forms ("rotor blade") fall back to phrase containment.
  function hayWords(hay) { return hay.split(/[^a-z0-9.]+/).filter(Boolean); }
  function tokenHits(tok, hay, words) {
    words = words || hayWords(hay);
    for (var i = 0; i < tok.forms.length; i++) {
      var f = tok.forms[i];
      if (!f) continue;
      if (f.indexOf(' ') >= 0) { if (hay.indexOf(f) >= 0) return true; continue; }
      for (var j = 0; j < words.length; j++) {
        var w = words[j];
        if (w === f || stem(w) === f) return true;
      }
    }
    return false;
  }
  function classify(q) {
    var n = norm(q);
    if (!n) return { intent: 'empty' };
    if (MAT_RE.test(n) || (/^[A-Z]{2}\./.test(n))) return { intent: 'material', n: n };
    if (/^\d{1,3}$/.test(n) && state.asm) return { intent: 'figure', n: n };
    if (/^\d{4,}$/.test(n)) return { intent: 'material_tail', n: n };
    return { intent: 'name', n: n, tokens: expandTokens(q) };
  }
  function search(q, families) {
    var c = classify(q); var out = [];
    if (c.intent === 'empty') return { intent: c, results: out };
    var fams = families || (state.data ? [state.data] : Object.keys(state.bundles).map(function (k) { return state.bundles[k]; }));
    fams.forEach(function (d) {
      d.mat.forEach(function (m, mi) {
        var mn = norm(m.m); var score = 0;
        if (c.intent === 'material') { if (mn === c.n) score = 100; else if (mn.indexOf(c.n) === 0) score = 60; else if (mn.indexOf(c.n) >= 0) score = 40; }
        else if (c.intent === 'material_tail') { if (mn.indexOf(c.n) >= 0) score = 50; }
        else if (c.intent === 'name') {
          // Haystack = DJI parts-list name + the linked Shopify product title +
          // its variant title, so sets, pairs and kits are findable by keyword.
          var prod = (typeof m.p === 'number' && d.parts) ? d.parts[m.p] : null;
          var name = ((m.n || '') + ' ' + (prod && prod.t ? prod.t : '') + ' ' + (prod && prod.vt ? prod.vt : '')).toLowerCase();
          var djiOnly = (m.n || '').toLowerCase();
          var nameWords = hayWords(name), djiWords = hayWords(djiOnly);
          var hit = 0, hitDji = 0;
          c.tokens.forEach(function (t) { if (tokenHits(t, name, nameWords)) hit++; if (tokenHits(t, djiOnly, djiWords)) hitDji++; });
          if (hit === c.tokens.length) score = 30 + hit + (hitDji === c.tokens.length ? 4 : 0);
          else if (hit > 0) score = 5 + hit;
        } else if (c.intent === 'figure') { return; }
        if (score > 0) {
          var locs = [];
          d.asm.forEach(function (a, ai) { a.pos.forEach(function (p) { if (p[1] === mi) locs.push({ ai: ai, fig: p[0] }); }); });
          out.push({ d: d, mi: mi, m: m, score: score, locs: locs });
        }
      });
    });
    if (c.intent === 'figure') {
      state.asm.pos.forEach(function (p) { if (String(p[0]) === String(parseInt(c.n, 10))) out.push({ d: state.data, mi: p[1], m: state.data.mat[p[1]], score: 100, locs: [{ ai: state.data.asm.indexOf(state.asm), fig: p[0] }] }); });
    }
    // Listed-for-sale parts rank above positions that are not listed yet. This is a
    // listing-state signal, not a commercial one: price, margin, promotions and stock
    // level never influence order. Unlisted positions are still returned - they are the
    // request-a-quote path - they just sit below the parts a customer can actually buy.
    function sellable(x) { var sp = x.m.p >= 0 ? x.d.parts[x.m.p] : null; return sp && sp.st === 'ACTIVE' ? 0 : 1; }
    out.sort(function (a, b) { return sellable(a) - sellable(b) || b.score - a.score || (a.m.n || '').localeCompare(b.m.n || ''); });
    return { intent: c, results: out.slice(0, 24) };
  }

  /* ---------------------------------------------------------------------------
     Catalog search.

     The bundle search above only knows parts that appear in DJI's exploded diagrams.
     Whole product families are therefore invisible to it: the DB2160 and DB1560
     flight batteries, the battery motherboards, the chargers and cooling stations are
     assemblies DJI never draws as numbered positions, so searching "battery" returned
     compartment brackets and cushions - diagram hardware - and none of the batteries
     the customer actually came to buy.

     Shopify's own predictive-search endpoint covers the whole catalog, so the finder
     asks it too and shows those products in a second group. Diagram matches still come
     first: they carry the position and material number, which is the stronger answer
     when it exists.
  --------------------------------------------------------------------------- */
  function catalogSearch(q) {
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
              '&resources[type]=product&resources[limit]=10' +
              '&resources[options][unavailable_products]=last';
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var ps = (j && j.resources && j.resources.results && j.resources.results.products) || [];
        // Products naming the chosen aircraft first - a T50 operator searching
        // "battery" wants the DB1560, not the T100's DB2160.
        var want = String(state.model || '').toUpperCase();
        if (want) ps = ps.slice().sort(function (a, b) {
          var am = String(a.title || '').toUpperCase().indexOf(want) >= 0 ? 0 : 1;
          var bm = String(b.title || '').toUpperCase().indexOf(want) >= 0 ? 0 : 1;
          return am - bm;
        });
        return ps;
      })
      .catch(function () { return []; });
  }

  /* ---------- render: shell ---------- */
  function renderShell() {
    root.innerHTML = '';
    root.appendChild(h('div', { class: 'apf-hero' }, [
      h('span', { class: 'apf-hero__eyebrow', text: 'Genuine DJI Agras replacement parts' }),
      h(HEADING_TAG, { class: 'h1', text: root.getAttribute('data-heading') || 'DJI Agras Parts Finder' }),
      h('p', { class: 'apf-hero__lede', text: root.getAttribute('data-lede') || 'Find the exact genuine part in two steps: select your aircraft, then pick the system and the exploded-view figure number — or search the DJI material number printed on the part.' }),
      h('p', { class: 'apf-step', text: 'Step A · Choose your aircraft' }),
      h('div', { class: 'apf-models', id: 'apf-models', role: 'group', 'aria-label': 'Aircraft model' }, MODELS.map(function (m) {
        return h('button', { class: 'apf-model', type: 'button', 'aria-pressed': 'false', 'data-model': m, onclick: function () { selectModel(m); } }, [m]);
      })),
      h('p', { class: 'apf-step', text: 'Or search' }),
      h('div', { class: 'apf-search' }, [
        h('form', { class: 'apf-search__box', role: 'search', onsubmit: function (e) { e.preventDefault(); runSearch(true); } }, [
          h('svg', { viewBox: '0 0 20 20', fill: 'none', stroke: 'currentColor', 'stroke-width': '2', html: '<circle cx="8.5" cy="8.5" r="5.5"/><path d="M13 13l5 5"/>' }),
          h('input', { type: 'search', id: 'apf-q', autocomplete: 'off', spellcheck: 'false', placeholder: 'Material number (YC.JG.ZS003588), part name, or figure no.', 'aria-label': 'Search parts', oninput: function () { runSearch(false); }, onkeydown: function (e) { if (e.key === 'Escape') closeResults(); } }),
          h('button', { class: 'apf-search__btn', type: 'submit', text: 'Search' })
        ]),
        h('p', { class: 'apf-search__intent', id: 'apf-intent', 'aria-live': 'polite' }),
        h('div', { class: 'apf-results', id: 'apf-results', hidden: true, role: 'listbox' })
      ]),
      h('div', { class: 'apf-hero__links', id: 'apf-links' })
    ]));
    root.appendChild(h('div', { id: 'apf-body' }));
    root.appendChild(h('div', { id: 'apf-bulk' }));
    document.addEventListener('click', function (e) { if (!e.target.closest('.apf-search')) closeResults(); });
  }
  function renderLinks() {
    var box = $('#apf-links'); box.innerHTML = '';
    if (state.data) box.appendChild(h('a', { href: '/collections/' + state.data.parent, 'data-ares-cta': 'collection', text: 'All ' + state.model + ' parts' }));
    box.appendChild(h('a', { href: CFG.doctorUrl + (state.model ? '?model=' + state.model : ''), 'data-ares-cta': 'doctor', text: 'Not sure what failed? Ask DJI Doctor' }));
    box.appendChild(h('a', { href: CFG.supportAnchor, 'data-ares-cta': 'support', text: 'Send us a photo / material number' }));
  }

  /* ---------- flow ---------- */
  function selectModel(m, silent) {
    state.model = m; state.family = MODEL_FAMILY[m]; state.system = null; state.asm = null; state.fig = null;
    $$('.apf-model').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-model') === m ? 'true' : 'false'); });
    $('#apf-body').innerHTML = '<div class="apf-loading">Loading ' + m + ' parts catalog…</div>';
    if (!silent) track('finder_model_selected', { model: m });
    return loadFamily(state.family).then(function (d) { state.data = d; renderLinks(); renderSystems(); setHash(); return d; })
      .catch(function () { $('#apf-body').innerHTML = '<div class="apf-empty">The parts catalog could not be loaded. Please refresh, or contact us with your material number.</div>'; });
  }
  // One system tile. The photograph is the same one the collection page shows -
  // the system collection's own image, or its first product - passed in from Liquid
  // so it never goes stale and costs no extra request.
  function systemTile(s, d) {
    var positions = s.a.reduce(function (n, ai) { return n + d.asm[ai].pos.length; }, 0);
    var src = CFG.systemImages[s.c];
    var media = h('span', { class: 'apf-systile__media' });
    if (src) media.appendChild(h('img', { src: src, alt: '', loading: 'lazy', decoding: 'async' }));
    else media.appendChild(h('span', { class: 'apf-systile__glyph', 'aria-hidden': 'true', text: SYSTEM_ICON[s.k] || '' }));
    var active = state.system === s.k;
    return h('button', {
      class: 'apf-systile' + (active ? ' is-active' : ''), type: 'button',
      'aria-pressed': active ? 'true' : 'false', 'data-system': s.k,
      onclick: function () { selectSystem(s.k); }
    }, [
      media,
      h('span', { class: 'apf-systile__body' }, [
        h('span', { class: 'apf-systile__title', text: s.l }),
        h('span', { class: 'apf-systile__cap', text: s.cap }),
        h('span', { class: 'apf-systile__meta', text: s.a.length
          ? (s.a.length + ' diagram' + (s.a.length === 1 ? '' : 's') + ' · ' + positions + ' positions')
          : 'Browse the collection →' })
      ])
    ]);
  }
  function renderSystems() {
    var d = state.data; var body = $('#apf-body'); body.innerHTML = '';
    var sec = h('section', { class: 'apf-section', id: 'apf-systems-sec' }, [
      h('div', { class: 'apf-section__head' }, [ h('div', {}, [
        h('p', { class: 'apf-eyebrow', text: 'Step B · Shop by DJI system' }),
        h('h2', { class: 'h2', text: d.label + ' parts by system' }),
        h('p', { class: 'apf-section__lede', text: 'Every DJI Agras part belongs to one aircraft system. Pick the system to cut hundreds of parts down to the ones that fit your repair.' })
      ]) ]),
      h('div', { class: 'apf-systiles' }, d.systems.map(function (s) { return systemTile(s, d); }))
    ]);
    body.appendChild(sec);
    body.appendChild(h('div', { id: 'apf-asms' }));
    body.appendChild(h('div', { id: 'apf-ws' }));
  }
  // Compact system switcher for the diagram workspace, so a technician who guessed
  // the wrong system does not have to scroll back to the tiles to change it.
  function systemStrip(current) {
    var d = state.data;
    return h('div', { class: 'apf-sysstrip', role: 'group', 'aria-label': 'Shop by system' }, [
      h('span', { class: 'apf-sysstrip__label', text: 'Shop by system' }),
      h('div', { class: 'apf-sysstrip__row' }, d.systems.map(function (s) {
        var on = s.k === current;
        return h('button', {
          class: 'apf-sysstrip__btn' + (on ? ' is-active' : ''), type: 'button',
          'aria-pressed': on ? 'true' : 'false',
          title: s.cap || s.l,
          onclick: function () {
            selectSystem(s.k);
            var box = $('#apf-asms'); if (box) box.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }, [(SYSTEM_ICON[s.k] || '') + ' ' + s.l]);
      }))
    ]);
  }
  function selectSystem(k, silent) {
    state.system = k; state.asm = null; state.fig = null;
    $$('.apf-systile').forEach(function (b) {
      var on = b.getAttribute('data-system') === k;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.classList.toggle('is-active', on);
    });
    $$('.apf-sysstrip__btn').forEach(function (b) { b.classList.remove('is-active'); b.setAttribute('aria-pressed', 'false'); });
    var s = state.data.systems.filter(function (x) { return x.k === k; })[0];
    var box = $('#apf-asms'); box.innerHTML = ''; $('#apf-ws').innerHTML = '';
    if (!silent) track('finder_system_selected', { system: k });
    if (!s.a.length) {
      box.appendChild(h('section', { class: 'apf-section' }, [
        h('div', { class: 'apf-empty', html: 'No exploded diagram is mapped for <b>' + s.l + '</b> on the ' + state.model + ' yet. Browse the collection instead: <a href="/collections/' + s.c + '" data-ares-cta="collection">' + s.l + ' parts →</a>' })
      ]));
      setHash(); return;
    }
    box.appendChild(h('section', { class: 'apf-section' }, [
      h('div', { class: 'apf-section__head' }, [
        h('div', {}, [ h('p', { class: 'apf-eyebrow', text: 'Assemblies in this system' }), h('h2', { class: 'h2', text: s.l + ' — assemblies' }) ]),
        h('a', { class: 'apf-btn apf-btn--ghost apf-btn--sm', href: '/collections/' + s.c, 'data-ares-cta': 'collection', text: 'Shop all ' + s.l.toLowerCase() + ' parts' })
      ]),
      h('div', { class: 'apf-asms' }, s.a.map(function (ai) {
        var a = state.data.asm[ai]; var listed = a.pos.filter(function (p) { var pt = partOf(p[1]); return pt && pt.st === 'ACTIVE'; }).length;
        return h('button', { class: 'apf-asm', type: 'button', onclick: function () { openAssembly(a); } }, [
          h('div', {}, [ h('p', { class: 'apf-asm__title', text: a.l }), h('span', { class: 'apf-asm__meta', text: a.pos.length + ' numbered positions · ' + listed + ' listed for sale' }) ]),
          h('span', { class: 'apf-asm__arrow', html: '&rarr;' })
        ]);
      }))
    ]));
    setHash();
    box.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  function openAssembly(a, fig, silent) {
    state.asm = a; state.fig = null; state.tab = 'diagram';
    if (!silent) track('finder_assembly_opened', { assembly: a.k });
    renderWorkspace();
    if (fig !== undefined && fig !== null) selectFigure(String(fig), true);
    else { var first = a.pos[0]; if (first) selectFigure(String(first[0]), true); }
    setHash();
    var ws = $('#apf-ws'); if (ws && !silent) ws.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /* ---------- workspace ---------- */
  function renderWorkspace() {
    var a = state.asm; var d = state.data; var sys = d.systems.filter(function (s) { return s.k === a.s; })[0];
    var ws = $('#apf-ws'); ws.innerHTML = '';
    ws.appendChild(h('section', { class: 'apf-ws', 'aria-label': a.l }, [
      h('div', { class: 'apf-ws__head' }, [
        h('div', {}, [
          h('ol', { class: 'apf-crumb' }, [
            h('li', {}, [h('button', { type: 'button', text: state.model, onclick: function () { state.asm = null; state.system = null; renderSystems(); setHash(); } })]),
            h('li', {}, [h('button', { type: 'button', text: sys ? sys.l : a.s, onclick: function () { selectSystem(a.s, true); } })]),
            h('li', { text: a.l })
          ]),
          h('h2', { class: 'apf-ws__title', text: a.l + ' — parts diagram' })
        ]),
        h('div', { class: 'apf-ws__actions' }, [
          h('a', { class: 'apf-btn apf-btn--ghost apf-btn--sm', href: '/collections/' + (sys ? sys.c : d.parent), 'data-ares-cta': 'collection', text: 'View collection' }),
          h('button', { class: 'apf-btn apf-btn--ghost apf-btn--sm', type: 'button', text: 'Copy link', onclick: function () { try { navigator.clipboard.writeText(location.href); toast('Link copied'); } catch (e) {} } })
        ])
      ]),
      systemStrip(a.s),
      h('div', { class: 'apf-tabs', role: 'tablist' }, [
        h('button', { class: 'apf-tab', role: 'tab', type: 'button', 'aria-selected': 'true', 'data-tab': 'diagram', text: 'Diagram & part', onclick: function () { switchTab('diagram'); } }),
        h('button', { class: 'apf-tab', role: 'tab', type: 'button', 'aria-selected': 'false', 'data-tab': 'list', text: 'Complete parts list (' + a.pos.length + ')', onclick: function () { switchTab('list'); } })
      ]),
      h('div', { class: 'apf-panel', id: 'apf-panel-diagram', role: 'tabpanel' }),
      h('div', { class: 'apf-panel', id: 'apf-panel-list', role: 'tabpanel', hidden: true })
    ]));
    renderDiagramPanel(); renderListPanel();
  }
  function switchTab(t) {
    state.tab = t; $$('.apf-tab').forEach(function (b) { b.setAttribute('aria-selected', b.getAttribute('data-tab') === t ? 'true' : 'false'); });
    $('#apf-panel-diagram').hidden = t !== 'diagram'; $('#apf-panel-list').hidden = t !== 'list'; setHash();
  }
  // A visual, shoppable index of every position in the assembly. Each tile is
  // the same selection affordance as the numbered button, so keyboard and
  // pointer users reach the identical part card.
  function assemblyGrid(a) {
    var wrap = h('div', { class: 'apf-grid', role: 'list', 'aria-label': a.l + ' parts' });
    var listedFirst = a.pos.slice().sort(function (x, y) {
      var px = partOf(x[1]), py = partOf(y[1]);
      var lx = px && px.st === 'ACTIVE' ? 0 : 1, ly = py && py.st === 'ACTIVE' ? 0 : 1;
      return lx - ly || Number(x[0]) - Number(y[0]);
    });
    listedFirst.forEach(function (pos) {
      var m = state.data.mat[pos[1]], part = partOf(pos[1]);
      var listed = part && part.st === 'ACTIVE';
      var tile = h('button', {
        class: 'apf-gtile' + (listed ? '' : ' apf-gtile--na'),
        type: 'button', role: 'listitem', 'data-fig': pos[0],
        onclick: function () { selectFigure(String(pos[0])); var c = $('#apf-card'); if (c) c.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }
      });
      var media = h('span', { class: 'apf-gtile__media' });
      if (part) {
        fetchLive(part).then(function (rec) {
          if (rec && rec.image) {
            var im = document.createElement('img');
            im.src = String(rec.image).replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2');
            im.alt = ''; im.loading = 'lazy'; im.decoding = 'async';
            media.innerHTML = ''; media.appendChild(im);
          }
        }).catch(function () {});
      }
      media.appendChild(h('span', { class: 'apf-gtile__no', text: 'No. ' + pos[0] }));
      tile.appendChild(media);
      tile.appendChild(h('span', { class: 'apf-gtile__name', text: (m.n || 'DJI part') }));
      tile.appendChild(h('span', { class: 'apf-gtile__mat', text: m.m }));
      tile.appendChild(h('span', { class: 'apf-gtile__foot', text: listed ? money(part.pr) : 'Request a quote' }));
      wrap.appendChild(tile);
    });
    return wrap;
  }

  function renderDiagramPanel() {
    var a = state.asm; var panel = $('#apf-panel-diagram'); panel.innerHTML = '';
    var fig = h('div', { class: 'apf-figure', id: 'apf-figure' });
    loadImages().then(function (imgs) {
      var url = a.img || (imgs && imgs[a.k]);
      if (url) { fig.innerHTML = ''; fig.appendChild(h('img', { src: url, alt: a.l + ' exploded parts diagram', loading: 'lazy' })); }
      else {
        // No exploded-view image exists for this assembly. Rather than hold the
        // largest block on the page with a grey placeholder, show the parts of
        // this assembly as a shoppable grid: real product photos, the DJI
        // material number, price and availability. The customer came here to
        // identify and buy a part, not to look at a picture of one.
        fig.innerHTML = '';
        fig.className = 'apf-figure apf-figure--grid';
        fig.appendChild(assemblyGrid(a));
      }
    });
    var nums = h('div', { class: 'apf-nums', id: 'apf-nums', role: 'group', 'aria-label': 'Diagram position' }, a.pos.map(function (p) {
      var pt = partOf(p[1]); var listed = pt && pt.st === 'ACTIVE';
      return h('button', { class: 'apf-num' + (listed ? '' : ' apf-num--na'), type: 'button', 'data-fig': p[0], 'aria-pressed': 'false', title: (state.data.mat[p[1]].n || '') + (listed ? '' : ' — not listed yet'), onclick: function () { selectFigure(String(p[0])); } }, [String(p[0])]);
    }));
    panel.appendChild(h('div', { class: 'apf-diagram' }, [
      h('div', {}, [
        fig,
        h('div', { class: 'apf-select' }, [
          h('div', { class: 'apf-select__head' }, [ h('h3', { text: 'Select a diagram number' }), h('span', { class: 'apf-note', style: 'margin:0', text: '● dot = not listed for sale yet' }) ]),
          nums
        ])
      ]),
      h('div', { class: 'apf-card', id: 'apf-card' }, [h('div', { class: 'apf-empty', text: 'Select a number on the diagram to see the part.' })])
    ]));
  }
  function selectFigure(fig, silent) {
    state.fig = fig;
    $$('.apf-num').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-fig') === fig ? 'true' : 'false'); });
    $$('#apf-panel-list tr[data-fig]').forEach(function (tr) { tr.classList.toggle('is-active', tr.getAttribute('data-fig') === fig); });
    var pos = state.asm.pos.filter(function (p) { return String(p[0]) === fig; })[0];
    if (!pos) return;
    if (!silent) track('finder_position_selected', { figure: fig, material: state.data.mat[pos[1]].m });
    renderCard(pos); setHash();
  }
  function renderCard(pos) {
    var d = state.data; var m = d.mat[pos[1]]; var part = partOf(pos[1]); var card = $('#apf-card'); card.innerHTML = '';
    var ps = partState(part);
    var locs = []; d.asm.forEach(function (x) { x.pos.forEach(function (p) { if (p[1] === pos[1] && x !== state.asm) locs.push(x.l + ' (No. ' + p[0] + ')'); }); });
    var badges = h('div', { class: 'apf-badges' }, [
      h('span', { class: 'apf-badge', text: 'No. ' + pos[0] }),
      h('span', { class: 'apf-badge ' + ps.cls, id: 'apf-card-state', text: ps.label }),
      part && part.fit && part.fit.length ? h('span', { class: 'apf-badge', text: 'Fits ' + part.fit.slice(0, 4).join(' · ') }) : null
    ]);
    card.appendChild(badges);
    card.appendChild(h('h3', { text: part ? part.t.replace(/\s*\([A-Z0-9.\s]+\)\s*$/, '') : (m.n || 'DJI part ' + m.m) }));
    var img = h('div', { class: 'apf-card__img', id: 'apf-card-img' }, [h('span', { class: 'apf-note', text: part ? 'Loading photo…' : 'No photo — not listed yet' })]);
    card.appendChild(img);
    var kv = h('dl', { class: 'apf-kv' }, [
      h('div', {}, [h('dt', { text: 'DJI material number' }), h('dd', { class: 'mono', text: m.m })]),
      h('div', {}, [h('dt', { text: 'Part name (DJI parts list)' }), h('dd', { text: m.n || '—' })]),
      // Price is shown only for a part that can actually be bought. A figure next to
      // "Not listed yet" reads as an offer the store cannot honour.
      part && part.st === 'ACTIVE' ? h('div', {}, [h('dt', { text: 'Price' }), h('dd', { id: 'apf-card-price', text: money(livePrice(part)) })]) : null,
      part && part.fit && part.fit.length ? h('div', {}, [h('dt', { text: 'Compatible models (per listing)' }), h('dd', { text: part.fit.join(', ') })]) : null,
      locs.length ? h('div', {}, [h('dt', { text: 'Also appears in' }), h('dd', { style: 'font-weight:400;font-size:1.3rem', text: locs.slice(0, 3).join(' · ') })]) : null
    ]);
    card.appendChild(kv);
    if (part && part.st === 'ACTIVE') {
      var qty = state.qty[part.h] || 1;
      card.appendChild(h('div', { class: 'apf-buy' }, [
        qtyControl(part.h, qty, function (v) { state.qty[part.h] = v; }),
        h('button', { class: 'apf-btn', type: 'button', id: 'apf-card-add', 'data-ares-cta': 'finder_add', text: 'Add to cart', onclick: function () { addLines([{ part: part, qty: state.qty[part.h] || 1 }], 'card'); } })
      ]));
      card.appendChild(h('div', { class: 'apf-card__links' }, [
        h('a', { href: '/products/' + part.h, 'data-ares-cta': 'product', text: 'View full product →' }),
        h('a', { href: CFG.supportAnchor, 'data-ares-cta': 'support', text: 'Ask a technician' })
      ]));
      card.appendChild(h('p', { class: 'apf-note', text: part.mt === 'sku_exact' ? 'Matched by DJI material number on the listing SKU.' : 'Matched from the listing description — confirm the material number before ordering.' }));
      fetchLive(part).then(function (l) {
        var im = $('#apf-card-img'); if (im) { im.innerHTML = ''; im.appendChild(l.image ? h('img', { src: l.image, alt: part.t, loading: 'lazy' }) : h('span', { class: 'apf-note', text: 'Photo coming soon' })); }
        var pr = $('#apf-card-price'); if (pr && l.price != null) pr.textContent = money(l.price);
        var st = $('#apf-card-state'); var ns = partState(part); if (st) { st.textContent = ns.label; st.className = 'apf-badge ' + ns.cls; }
        var add = $('#apf-card-add');
        if (l.ambiguous) {
          // The listing carries several variants under this one material number and
          // nothing identifies which the position means. Hand the choice to the
          // customer on the listing rather than picking for them.
          var buy = add && add.parentNode;
          if (buy) {
            buy.innerHTML = '';
            buy.appendChild(h('a', { class: 'apf-btn', href: '/products/' + part.h, 'data-ares-cta': 'choose_variant', text: 'Choose the exact variant →' }));
          }
          var note = h('p', { class: 'apf-note apf-note--warn', text: 'This listing covers ' + l.variantCount + ' variants under the same DJI material number. Pick the one that matches your aircraft and position on the product page so you receive the right part.' });
          if (buy && buy.parentNode) buy.parentNode.insertBefore(note, buy);
          track('finder_variant_ambiguous', { material: m.m, handle: part.h, variants: l.variantCount });
        } else if (add) {
          add.disabled = !l.available;
          if (l.variantTitle && l.variantCount > 1) {
            add.parentNode.appendChild(h('span', { class: 'apf-note', style: 'flex-basis:100%;margin:.6rem 0 0', text: 'Variant: ' + l.variantTitle }));
          }
        }
      });
    } else {
      card.appendChild(h('p', { class: 'apf-note', html: 'This DJI part is in the ' + state.model + ' parts list but is not listed for sale yet. <b>Ask us and we will source it</b> — include the material number ' + m.m + '.' }));
      card.appendChild(h('div', { class: 'apf-buy' }, [
        h('a', { class: 'apf-btn', href: CFG.supportAnchor, 'data-ares-cta': 'request_part', text: 'Request this part', onclick: function () { prefillSupport(m); } })
      ]));
    }
  }
  function prefillSupport(m) {
    var ta = document.querySelector(CFG.supportAnchor + ' textarea'); var mat = document.querySelector(CFG.supportAnchor + ' input[name="contact[DJI material number]"]');
    if (mat) mat.value = m.m;
    if (ta && !ta.value) ta.value = 'Please quote: ' + (m.n || 'DJI part') + ' (' + m.m + ') for my DJI Agras ' + (state.model || '') + (state.asm ? ' — ' + state.asm.l + ' No. ' + state.fig : '') + '.';
    track('finder_part_requested', { material: m.m });
  }
  function qtyControl(key, value, onChange) {
    var input = h('input', { type: 'number', min: '1', max: '99', value: String(value), 'aria-label': 'Quantity', oninput: function () { var v = Math.max(1, Math.min(99, parseInt(input.value, 10) || 1)); onChange(v); updateBulk(); } });
    return h('div', { class: 'apf-qty' }, [
      h('button', { type: 'button', 'aria-label': 'Decrease', text: '−', onclick: function () { var v = Math.max(1, (parseInt(input.value, 10) || 1) - 1); input.value = v; onChange(v); updateBulk(); } }),
      input,
      h('button', { type: 'button', 'aria-label': 'Increase', text: '+', onclick: function () { var v = Math.min(99, (parseInt(input.value, 10) || 1) + 1); input.value = v; onChange(v); updateBulk(); } })
    ]);
  }

  /* ---------- complete parts list ---------- */
  function renderListPanel() {
    var a = state.asm; var d = state.data; var panel = $('#apf-panel-list'); panel.innerHTML = '';
    var rows = a.pos.map(function (p) { return { fig: String(p[0]), m: d.mat[p[1]], part: partOf(p[1]) }; });
    var selAll = h('input', { type: 'checkbox', id: 'apf-selall', onchange: function () { rows.forEach(function (r) { if (r.part && r.part.st === 'ACTIVE') state.sel[r.part.h] = selAll.checked; }); syncSelection(); } });
    panel.appendChild(h('div', { class: 'apf-list__bar' }, [
      h('label', {}, [selAll, 'Select all listed']),
      h('span', { class: 'apf-list__sum', id: 'apf-sum', html: '<b>0</b> selected · <b>' + money(0) + '</b>' }),
      h('button', { class: 'apf-btn apf-btn--sm', type: 'button', id: 'apf-bulk-add', text: 'Add selected to cart', onclick: function () { addSelected(); } }),
      h('button', { class: 'apf-btn apf-btn--ghost apf-btn--sm', type: 'button', text: 'Clear', onclick: function () { state.sel = {}; syncSelection(); } })
    ]));
    var tbody = h('tbody', {}, rows.map(function (r) {
      var part = r.part; var listed = part && part.st === 'ACTIVE'; var ps = partState(part);
      var qty = part ? (state.qty[part.h] || 1) : 1;
      return h('tr', { 'data-fig': r.fig, 'aria-selected': listed && state.sel[part.h] ? 'true' : 'false' }, [
        h('td', {}, [listed ? h('input', { type: 'checkbox', 'aria-label': 'Select ' + (r.m.n || r.m.m), checked: !!state.sel[part.h], onchange: function (e) { state.sel[part.h] = e.target.checked; syncSelection(); } }) : '']),
        h('td', { class: 'num', text: r.fig }),
        h('td', { class: 'mono', text: r.m.m }),
        h('td', {}, [h('span', { class: 'apf-rowname' }, [h('button', { type: 'button', text: r.m.n || (part ? part.t : '—'), onclick: function () { switchTab('diagram'); selectFigure(r.fig); $('#apf-card').scrollIntoView({ behavior: 'smooth', block: 'center' }); } })])]),
        h('td', { text: part && part.fit ? part.fit.slice(0, 3).join(', ') : '—' }),
        h('td', {}, [h('span', { class: 'apf-stock apf-stock--' + (ps.key === 'ok' ? 'ok' : ps.key === 'oos' ? 'low' : 'no'), text: ps.label })]),
        h('td', { class: 'num', text: part ? money(livePrice(part)) : '—' }),
        h('td', {}, [listed ? qtyControl(part.h, qty, function (v) { state.qty[part.h] = v; }) : '']),
        h('td', {}, [listed ? h('button', { class: 'apf-btn apf-btn--sm', type: 'button', text: 'Add', 'data-ares-cta': 'finder_add_row', onclick: function () { addLines([{ part: part, qty: state.qty[part.h] || 1 }], 'row'); } })
                            : h('a', { class: 'apf-btn apf-btn--ghost apf-btn--sm', href: CFG.supportAnchor, text: 'Request', onclick: function () { prefillSupport(r.m); } })])
      ]);
    }));
    panel.appendChild(h('div', { class: 'apf-table-wrap' }, [
      h('table', { class: 'apf-table' }, [
        h('thead', {}, [h('tr', {}, ['Select', 'No.', 'Material number', 'Part name', 'Fits', 'Stock', 'Price', 'Qty', 'Add'].map(function (t) { return h('th', { text: t }); }))]),
        tbody
      ])
    ]));
    panel.appendChild(h('div', { class: 'apf-mobile-cards' }, rows.map(function (r) {
      var part = r.part; var listed = part && part.st === 'ACTIVE'; var ps = partState(part);
      return h('div', { class: 'apf-mcard' }, [
        h('div', { class: 'apf-mcard__fig', text: r.fig }),
        h('div', { class: 'apf-mcard__body' }, [h('div', { text: r.m.n || (part ? part.t : '—') }), h('div', { class: 'mono', text: r.m.m }), h('div', { class: 'apf-stock apf-stock--' + (ps.key === 'ok' ? 'ok' : ps.key === 'oos' ? 'low' : 'no'), text: ps.label + (part ? ' · ' + money(livePrice(part)) : '') })]),
        h('div', { class: 'apf-mcard__foot' }, [
          listed ? h('label', { style: 'display:inline-flex;gap:.5rem;align-items:center;font-size:1.3rem' }, [h('input', { type: 'checkbox', checked: !!state.sel[part.h], onchange: function (e) { state.sel[part.h] = e.target.checked; syncSelection(); } }), 'Select']) : h('span', { class: 'apf-note', text: 'Not listed yet' }),
          listed ? h('button', { class: 'apf-btn apf-btn--sm', type: 'button', text: 'Add', onclick: function () { addLines([{ part: part, qty: state.qty[part.h] || 1 }], 'row'); } })
                 : h('a', { class: 'apf-btn apf-btn--ghost apf-btn--sm', href: CFG.supportAnchor, text: 'Request', onclick: function () { prefillSupport(r.m); } })
        ])
      ]);
    })));
    syncSelection();
  }
  function selectedLines() {
    var d = state.data; if (!d) return [];
    return d.parts.filter(function (p) { return state.sel[p.h] && p.st === 'ACTIVE'; }).map(function (p) { return { part: p, qty: state.qty[p.h] || 1 }; });
  }
  function syncSelection() {
    $$('#apf-panel-list input[type=checkbox]').forEach(function (cb) {
      var tr = cb.closest('tr'); var label = cb.getAttribute('aria-label') || '';
      if (tr) { var fig = tr.getAttribute('data-fig'); var pos = state.asm.pos.filter(function (p) { return String(p[0]) === fig; })[0]; var part = pos ? partOf(pos[1]) : null; if (part) { cb.checked = !!state.sel[part.h]; tr.setAttribute('aria-selected', cb.checked ? 'true' : 'false'); } }
    });
    updateBulk();
  }
  function updateBulk() {
    var lines = selectedLines(); var units = 0, total = 0;
    lines.forEach(function (l) { units += l.qty; total += livePrice(l.part) * l.qty; });
    var sum = $('#apf-sum'); if (sum) sum.innerHTML = '<b>' + lines.length + '</b> selected · <b>' + units + '</b> unit' + (units === 1 ? '' : 's') + ' · <b>' + money(total) + '</b>';
    var bar = $('#apf-bulk'); bar.innerHTML = '';
    if (lines.length) bar.appendChild(h('div', { class: 'apf-bulkbar', role: 'status' }, [
      h('div', {}, [h('b', { text: lines.length + ' part' + (lines.length === 1 ? '' : 's') + ' · ' + units + ' unit' + (units === 1 ? '' : 's') }), h('br'), h('span', { text: money(total) + ' · catalog price' })]),
      h('button', { class: 'apf-btn', type: 'button', text: 'Add selected to cart', onclick: addSelected }),
      h('button', { class: 'apf-btn apf-btn--ghost apf-btn--sm', type: 'button', style: 'color:#fff;border-color:rgba(255,255,255,.4)', text: 'Clear', onclick: function () { state.sel = {}; syncSelection(); } })
    ]));
  }
  function addSelected() { var lines = selectedLines(); if (!lines.length) { toast('Select at least one listed part', true); return; } addLines(lines, 'bulk'); }

  /* ---------- cart ---------- */
  function addLines(lines, source) {
    var blocked = lines.filter(function (l) { var lv = state.live[l.part.h]; return lv && lv.ambiguous; });
    if (blocked.length) {
      toast('Choose the exact variant on the product page for ' + blocked.length + ' part' + (blocked.length === 1 ? '' : 's'), true);
      track('finder_add_blocked_ambiguous', { source: source, lines: blocked.length, handles: blocked.map(function (l) { return l.part.h; }) });
      lines = lines.filter(function (l) { var lv = state.live[l.part.h]; return !(lv && lv.ambiguous); });
      if (!lines.length) return;
    }
    var items = lines.filter(function (l) { return l.part && l.part.vid; }).map(function (l) {
      var live = state.live[l.part.h]; var vid = live && live.variantId ? live.variantId : l.part.vid;
      return { id: vid, quantity: l.qty, properties: { _source: 'parts_finder', _diagram: state.asm ? state.asm.k : '', _material: (function () { var mm = state.data.mat.filter(function (m) { return m.p >= 0 && state.data.parts[m.p].h === l.part.h; })[0]; return mm ? mm.m : ''; })() } };
    });
    if (!items.length) return;
    var btns = $$('.apf-btn'); btns.forEach(function (b) { b.disabled = true; });
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items, sections: 'cart-icon-bubble' }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        btns.forEach(function (b) { b.disabled = false; });
        if (!res.ok) { toast(res.j && (res.j.description || res.j.message) || 'Could not add to cart', true); track('finder_add_failed', { source: source, error: res.j && res.j.description }); return; }
        try { if (res.j.sections && res.j.sections['cart-icon-bubble']) { var b = document.getElementById('cart-icon-bubble'); if (b) b.innerHTML = res.j.sections['cart-icon-bubble']; } } catch (e) {}
        var units = items.reduce(function (n, i) { return n + i.quantity; }, 0);
        toast('Added ' + units + ' item' + (units === 1 ? '' : 's') + ' to your cart', false, true);
        track(source === 'bulk' ? 'finder_bulk_added' : 'finder_part_added', { source: source, lines: items.length, units: units, variant_ids: items.map(function (i) { return i.id; }) });
        if (source === 'bulk') { state.sel = {}; syncSelection(); }
        try { document.dispatchEvent(new CustomEvent('ares:cart-added', { detail: { items: items } })); } catch (e) {}
      }).catch(function () { btns.forEach(function (b) { b.disabled = false; }); toast('Network error — please try again', true); });
  }
  var toastTimer;
  function toast(msg, err, cartLink) {
    var old = $('.apf-toast'); if (old) old.remove();
    var t = h('div', { class: 'apf-toast' + (err ? ' apf-toast--err' : ''), role: 'status' }, [msg, cartLink ? h('a', { href: '/cart', text: 'View cart →' }) : null]);
    root.appendChild(t); clearTimeout(toastTimer); toastTimer = setTimeout(function () { t.remove(); }, 5000);
  }

  /* ---------- search UI ---------- */
  var searchTimer;
  function runSearch(submit) {
    var q = $('#apf-q').value; state.q = q;
    clearTimeout(searchTimer);
    var go = function () {
      var c = classify(q); var intent = $('#apf-intent');
      if (c.intent === 'empty') { intent.textContent = ''; closeResults(); return; }
      var ready = state.data ? Promise.resolve([state.data]) : Promise.all(['t100', 't50', 't40'].map(loadFamily));
      Promise.all([ready, catalogSearch(q)]).then(function (both) {
        var fams = both[0], cat = both[1] || [];
        var r = search(q, fams);
        // A product already shown as a diagram position is not repeated below.
        var seen = {};
        r.results.forEach(function (x) { var pp = x.m.p >= 0 ? x.d.parts[x.m.p] : null; if (pp) seen[pp.h] = 1; });
        cat = cat.filter(function (p) { return !seen[p.handle]; });
        var label = { material: 'Searching DJI material number', material_tail: 'Searching material numbers ending in', figure: 'Looking up figure number in ' + (state.asm ? state.asm.l : 'this diagram'), name: 'Searching part names for' }[r.intent.intent];
        var total = r.results.length + cat.length;
        intent.innerHTML = label + ' <b>' + escapeHtml(q.trim()) + '</b>' + (state.data ? ' · ' + state.model : ' · all models') + (total ? ' — ' + total + ' match' + (total === 1 ? '' : 'es') : ' — no matches');
        renderResults(r, cat);
        if (submit) track(total ? 'finder_search_submitted' : 'finder_search_zero_result', { query: q, intent: r.intent.intent, results: r.results.length, catalog_results: cat.length });
      });
    };
    if (submit) go(); else searchTimer = setTimeout(go, 180);
  }
  function escapeHtml(s) { return s.replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function renderResults(r, cat) {
    cat = cat || [];
    var box = $('#apf-results'); box.innerHTML = '';
    if (!r.results.length && !cat.length) {
      box.appendChild(h('div', { style: 'padding:1.2rem 1rem;font-size:1.35rem;color:#374151', html: 'No part matches <b>' + escapeHtml(state.q) + '</b>. Check the material number on the part label, or <a href="' + CFG.supportAnchor + '" data-ares-cta="support">send us a photo</a> and we will identify it.' }));
      box.hidden = false; return;
    }
    if (r.results.length) box.appendChild(h('p', { class: 'apf-resgroup', text: 'On the parts diagrams' }));
    r.results.forEach(function (x) {
      var part = x.m.p >= 0 ? x.d.parts[x.m.p] : null; var ps = partState(part);
      var ctx = (x.d.models[0]) + (x.locs.length ? ' · ' + x.d.asm[x.locs[0].ai].l + ' No. ' + x.locs[0].fig + (x.locs.length > 1 ? ' +' + (x.locs.length - 1) : '') : '');
      box.appendChild(h('button', { class: 'apf-result', type: 'button', role: 'option', onclick: function () { goToResult(x); } }, [
        h('span', { class: 'apf-result__mat', text: x.m.m }),
        h('span', {}, [h('div', { class: 'apf-result__name', text: x.m.n || (part ? part.t : '') }), h('div', { class: 'apf-result__ctx', text: ctx })]),
        h('span', { class: 'apf-result__state', style: 'color:' + (ps.key === 'ok' ? '#1f7a3a' : ps.key === 'oos' ? '#b7791f' : '#6b7280'), text: part ? ps.label + ' · ' + money(livePrice(part)) : 'Not listed' })
      ]));
    });
    if (cat.length) {
      box.appendChild(h('p', { class: 'apf-resgroup', text: r.results.length ? 'Elsewhere in the catalog' : 'In the catalog' }));
      cat.forEach(function (p) {
        var img = p.featured_image || p.image || null;
        var src = typeof img === 'string' ? img : (img && img.url) || null;
        var media = h('span', { class: 'apf-result__media' });
        if (src) media.appendChild(h('img', { src: String(src).replace(/(\.[a-z]+)(\?|$)/i, '_80x$1$2'), alt: '', loading: 'lazy' }));
        box.appendChild(h('a', {
          class: 'apf-result apf-result--cat', href: p.url || ('/products/' + p.handle),
          'data-ares-cta': 'catalog_result',
          onclick: function () { track('finder_catalog_result_selected', { handle: p.handle, query: state.q }); }
        }, [
          media,
          h('span', {}, [
            h('div', { class: 'apf-result__name', text: p.title || p.handle }),
            h('div', { class: 'apf-result__ctx', text: 'Product listing — not a numbered diagram position' })
          ]),
          h('span', { class: 'apf-result__state', text: p.price ? String(p.price) : '' })
        ]));
      });
    }
    box.hidden = false;
  }
  function closeResults() { var b = $('#apf-results'); if (b) b.hidden = true; }
  function goToResult(x) {
    closeResults(); track('finder_search_result_selected', { material: x.m.m });
    var fam = x.d.fam; var model = state.model && MODEL_FAMILY[state.model] === fam ? state.model : x.d.models[0];
    var after = function () {
      if (x.locs.length) { var a = state.data.asm[x.locs[0].ai]; selectSystem(a.s, true); openAssembly(a, x.locs[0].fig); }
    };
    if (state.data && state.data.fam === fam) after(); else selectModel(model, true).then(after);
  }

  /* ---------- boot ---------- */
  renderShell(); renderLinks();
  var p = readParams();
  var model = (p.model || '').toUpperCase(); if (model === 'T70' ) model = 'T70P';
  var boot = Promise.resolve();
  if (MODEL_FAMILY[model]) {
    boot = selectModel(model, true).then(function () {
      if (p.system) selectSystem(p.system, true);
      if (p.asm) { var a = state.data.asm.filter(function (x) { return x.k === p.asm; })[0]; if (a) { selectSystem(a.s, true); openAssembly(a, p.fig, true); if (p.tab === 'list') switchTab('list'); } }
      if (p.view === 'diagrams' && !p.system) { var s = $('#apf-systems-sec'); if (s) s.scrollIntoView({ behavior: 'smooth' }); }
    });
  }
  // A query in the URL runs only after the aircraft's catalog has loaded, otherwise the
  // search fires against every family and returns parts for the wrong aircraft first.
  if (p.q) { $('#apf-q').value = p.q; boot.then(function () { runSearch(true); }); }
  track('finder_started', { has_model: !!MODEL_FAMILY[model] });
})();